import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { ClientSdkSiteConfig } from '../types'
import type { TPAPublicClientSpecEntry } from '@wix/thunderbolt-ssr-api'

const clientSdkSiteConfig: SiteConfigFn<ClientSdkSiteConfig> = ({ api }) => {
	const clientSpecMap = api.rendererModel.getClientSpecMap() || {}

	const appDefinitionIds: Array<string> = []
	for (const app of Object.values(clientSpecMap)) {
		const typedApp = app as TPAPublicClientSpecEntry
		const widgets = typedApp.widgets
		if (!widgets) {
			continue
		}
		const hasDependencies = Object.values(widgets).some(
			(widget) => (widget.componentFields?.dependencies ?? []).length > 0
		)
		if (hasDependencies) {
			appDefinitionIds.push(typedApp.appDefinitionId)
		}
	}

	const shouldLoad = appDefinitionIds.length > 0

	return {
		shouldLoadSiteFeature: shouldLoad,
		shouldLoadSiteConfig: shouldLoad,
		siteConfig: { appDefinitionIds },
	}
}

const name = 'clientSdk'

export const config = { site: clientSdkSiteConfig, name }
